<template>
  <div class="input-radio-item">
    <input
      type="radio"
      :id="name + label"
      :value="value || label"
      v-model="form[name]"
    />
    <label :for="name + label" class="radio-label">{{ label }}</label>
  </div>
</template>

<script>
import ControlMixin from "./../../mixins/ControlMixin";
export default {
  mixins: [ControlMixin],
  props: ["name", "label", "value"],
};
</script>
